export default __webpack_public_path__ + "static/todos_primos_nissan-f8b31cf6d9a667f183092a98b3f7ce98.jpg";